module.exports = __webpack_public_path__ + "img/no-share.295ef578.svg";